import { t } from 'i18next';
import { ObjectValues } from 'src/common/tsHelpers';

export const ACTIVE_PROFILE = {
  PRIMARY: 1,
  SECONDARY: 2,
};

export type ActiveProfile = ObjectValues<typeof ACTIVE_PROFILE>;

export const ACTIVE_PROFILE_FILTER = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  ANY: 'ANY',
} as const;

export type ActiveProfileFilter = ObjectValues<typeof ACTIVE_PROFILE_FILTER>;

export const mapLastActiveProfileFilterToValue = (value: Omit<ActiveProfileFilter, 'ANY'>) => {
  switch (value) {
    case ACTIVE_PROFILE_FILTER.PRIMARY:
      return ACTIVE_PROFILE.PRIMARY;
    case ACTIVE_PROFILE_FILTER.SECONDARY:
      return ACTIVE_PROFILE.SECONDARY;
  }
};

export const mapLastActiveProfileFilterTLabel = (value: ActiveProfileFilter) => {
  switch (value) {
    case 'PRIMARY':
      return t('rSimInventory.primary');
    case 'SECONDARY':
      return t('rSimInventory.backup');
  }

  return '';
};
